<template>
  <div style="display: flex;align-items: center;position: relative;">
    <div class="brand-filters"
      v-if="list.length>0">
      <div v-for="(item,index) in list"
        :key="item.label"
        class="brand-filter"
        :class="{ active: item.active }"
        :style="{'background': item.active?selectBrandBg:noSelectBrandBg,marginRight:index==list.length-1?'20px':0}"
        @click="selectBrand(item)">
        {{ item.label }}
      </div>
    </div>
    <div class="view-all-wrapper"
      v-if="list.length>0">
      <div class="view-all"
        @click="handleViewAll">
        <!-- {{$t('viewAll')}} -->
        <i :class="showAllBrand?'el-icon-arrow-up':'el-icon-arrow-down'"
          style="font-weight: bold;font-size: 18px;"></i>
      </div>
    </div>

    <el-dialog :title="$t('selectBrand')"
      center
      :visible.sync="showAllBrand"
      :width="isMobile?'90%':'40%'"
      :show-close="false"
      :modal-append-to-body="false">
      <div class="popup-layout">
        <div class="popup-content">
          <div v-for="item in list"
            :key="item.label"
            class="brand-filter"
            :class="{ active: item.active }"
            :style="{'background': item.active?selectBrandBg:noSelectBrandBg}"
            @click="selectBrand(item);hideBrandPopup()">
            {{ item.label }}
          </div>
        </div>
      </div>
      <span slot="footer"
        class="dialog-footer">
        <el-button type="primary"
          @click="showAllBrand = false">
          {{$t('close')}}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
	import productApi from '@/api/product'
	export default {
		name: 'brandList',
		props: {
			expertId: {
				type: Number,
				default: null
			},
			categoryName: {
				type: String,
				default: null
			}
		},
		data() {
			return {
				isMobile: window.innerWidth < 768,
				list: [],
				showAllBrand: false,
				noSelectBrandBg: '#373737',
				selectBrandBg: '#486AFF'
			}
		},
		methods: {
			//页面初始化方法
			init() {
				if (this.expertId) {
					this.getGoodsBrand();
					var styleConfig = this.$styleManager.getCurrentConfig();
					if (styleConfig) {
						this.noSelectBrandBg = styleConfig.backgroundColor == '#0B0B0B' ? '#373737' : '#E8E8E9';
					}
					if (styleConfig) {
						this.selectBrandBg = styleConfig.themeColor;
					}
				}
			},
			//获取商品分类
			async getGoodsBrand() {
				var params = {
					expertId: this.expertId
				}
				if (this.categoryName) {
					if (this.categoryName != 'New Arrivals' && this.categoryName != 'Best Sellers') {
						params.categoryName = this.categoryName
					}
				}
				const res = await productApi.getGoodsBrandList(params);
				this.list = res.data || [];
				if (this.list.length != 0) {
					this.list.map(item => {
						item.label = item.brandName;
						item.active = false;
					})
					this.list.unshift({
						label: this.$t('all'),
						active: true
					})
					var other = this.list.find(item => item.brandName == 'Other' || item.brandName == 'other' || item
						.brandName == 'OTHER');
					if (other) {
						var index = this.list.indexOf(other);
						this.list.splice(index, 1);
						this.list.push(other);
					}
				}
			},
			// 选择分类
			selectBrand(brand) {
				this.list.map(item => {
					item.active = false;
				})
				brand.active = true;
				this.$forceUpdate();
				this.$emit('brand-selected', brand);
			},
			// 处理查看全部
			handleViewAll() {
				this.showAllBrand = !this.showAllBrand;
			},
			// 隐藏品牌弹窗
			hideBrandPopup() {
				this.showAllBrand = false;
			}
		}
	}
</script>

<style scoped>
	:deep .el-dialog--center .el-dialog__body {
		padding: 0 20px;
	}

	.view-all-wrapper {
		position: relative;
		display: flex;
		flex-direction: column;
		align-items: center;
		box-shadow: -10px -1px 10px var(--background-color);
		position: absolute;
		right: 0;
		z-index: 99;
		padding: 5px 0;
	}

	.caret-top {
		font-size: 30px;
		color: var(--pupop-bg-color);
		z-index: 1001;
		position: absolute;
		top: -20px;
		right: 35px;
	}

	.brand-filters {
		gap: 10px;
		display: flex;
		flex-wrap: nowrap;
		overflow-x: auto;
		padding-top: 10px;
		/* 默认隐藏滚动条 */
		scrollbar-width: thin;
		scrollbar-color: transparent transparent;
		position: relative;
		z-index: 10;
		width: 100%;
		max-width: 1100px;
	}

	/* 鼠标移入时显示滚动条 */
	.brand-filters:hover {
		scrollbar-color: #ccc transparent;
	}

	/* WebKit浏览器滚动条样式 */
	.brand-filters::-webkit-scrollbar {
		width: 1px;
		height: 1px;
	}

	.brand-filters::-webkit-scrollbar-track {
		background: transparent;
	}

	.brand-filters::-webkit-scrollbar-thumb {
		background-color: transparent;
		border-radius: 3px;
	}

	.brand-filters:hover::-webkit-scrollbar-thumb {
		background-color: #ccc;
	}

	/* 悬浮弹窗包装器 */
	.popup-wrapper {
		position: absolute;
		top: 100%;
		left: 100%;
		transform: translateX(-100%);
		z-index: 11;
		margin-top: 25px;
	}

	/* 悬浮弹窗样式 */
	.popup-layout {
		max-height: 300px;
		overflow-y: auto;
		/* 滚动条美化 */
		scrollbar-width: thin;
	}

	.popup-content {
		gap: 10px;
		padding: 15px 0;
		display: flex;
		align-items: center;
		flex-wrap: wrap;
	}

	.brand-filter {
		padding: 10px 20px;
		border-radius: 10px;
		color: var(--link-color);
		cursor: pointer;
		font-size: 17px;
		transition: all 0.3s ease;
		flex-shrink: 0;
		white-space: nowrap;
		position: relative;
		z-index: 9998 !important;
		/* 确保分类过滤器不会裁剪下拉菜单 */
		overflow: visible !important;
	}

	.brand-filter.active {
		font-weight: bold;
		color: #fff;
		background: var(--primary-color);
	}

	.view-all {
		text-align: center;
		width: 60px;
		cursor: pointer;
		color: var(--primary-color);
		font-weight: bold;
	}

	/* 响应式调整 */
	@media (max-width: 1200px) {
		.brand-filters {
			max-width: calc(100% - 60px);
		}
	}

	@media (max-width: 768px) {
		.brand-filters {
			gap: 10px;
			padding: 5px 0;
			max-width: calc(100% - 60px);
		}

		.brand-filter {
			padding: 6px 12px;
			font-size: 15px;
		}

		.popup-content {
			padding: 0;
		}

		.view-all {
			width: 50px;
			font-size: 15px;
		}

		.popup-wrapper {
			left: auto;
			right: 0;
			transform: none;
			margin-top: 15px;
		}
	}

	@media (max-width: 480px) {
		.brand-filter {
			padding: 6px 12px;
			font-size: 15px;
		}

		.caret-top {
			top: -16px;
		}

		.view-all {
			width: 50px;
			font-size: 15px;
		}

		.caret-top {
			font-size: 24px;
		}
	}
</style>